<template>
  <div>
    <a-input-search style="margin-bottom: 8px" placeholder="Search" @change="onChange" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MeterSearch',
  components: {

  },
  data () {
    return {
      options: {
      }
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'queue',
      'currentImage'
    ])
  },
  methods: {
    onExpand  (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange (e) {
      // const value = e.target.value
    }
  }
}
</script>
